import { GridList, Paper, Typography } from "@material-ui/core";
import { useEffect, useReducer, useState } from "react";
import CloseImage from '../../assets/ic_close.png';
import api from "../api";
import { format } from 'date-fns';


export default function SHSAllRegis(props) {
    const [datatable, setDatatable] = useState([])
    const [data, setStopItem] = useState({})
    const [visibleStatus, setVisibleStatus] = useState(false)
    const [create, setCreate] = useState(false);
    const [read, setRead] = useState(false);
    const [update, setUpdate] = useState(false);
    const [deleted, setDeleted] = useState(false);

    useEffect(() => {
        props.setShowNotif(true)
        getPermission(props)
        getDataList()
    }, [])

    const getPermission = (e) => {
        api.create().getPermission(e.menuid).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let data = response.data.data
                    setCreate(data.create)
                    setUpdate(data.update)
                    setRead(data.read)
                    setDeleted(data.delete)
                }
            }
        })
    }

    const getDataList = () => {
        api.create().getListSessionFacilityByCategory("All Registration").then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let data = []
                    response.data.data.map((item) => {
                        if (item.facility_status === "Aktif") {
                            data.push(item)
                        }
                    })
                    setDatatable(data)
                }
            }
        })
    }

    const handleStart = (item) => {
        let payload = {
            "facility_schedule_id": item.facility_schedule_id,
            "status": 1
        }
        api.create().updateSession(payload).then(response => {
            console.log(response);
            getDataList()
            forceUpdate()
        })
    }

    const handleHold = (item) => {
        let payload = {
            "facility_schedule_id": item.facility_schedule_id,
            "status": 2
        }
        api.create().updateSession(payload).then(response => {
            console.log(response);
            getDataList()
            forceUpdate()
        })
    }

    const changeStatus = () => {
        let payload = {
            "facility_schedule_id": data.facility_schedule_id,
            "status": 3
        }
        api.create().updateSession(payload).then(response => {
            console.log(response);
            getDataList()
            setVisibleStatus(false)
            forceUpdate()
        })
    }

    const handleStop = (item) => {
        setStopItem(item)
        setVisibleStatus(true)
    }

    const forceUpdate = useReducer(bool => !bool)[1];

    return (
        <div>
            {read && (
                <div style={{ padding: 20, margin: 'auto' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', paddingLeft: 10, paddingRight: 10 }}>
                        <Typography style={{ color: '#2a9c6c', fontWeight: 'bold', fontFamily: 'Poppins' }}>Kelola Loket</Typography>
                    </div>
                    <div style={{ overflow: 'scroll', margin: 'auto', maxHeight: props.height - 200, marginTop: 20 }}>
                        <GridList cellHeight={240} cols={4} style={{ justifyContent: datatable.length % 2 === 0 ? 'flex-start' : 'space-between' }} spacing={'5%'}>
                            {datatable.map((item, index) => (
                                <Paper style={{ display: 'grid', height: 220, borderRadius: 20, boxShadow: '5px 5px 10px 0 #999999', margin: 10, padding: 10, width: 450 }}>
                                    <div style={{ display: 'flex', width: '100%' }}>
                                        {/* <div style={{ backgroundColor: 'green', width: 60, height: 60, borderRadius: 30 }} /> */}
                                        <div style={{ marginLeft: 20 }}>
                                            <Typography style={{ fontWeight: 'bold', fontFamily: 'Poppins' }}>{item.facility_name.toUpperCase()}</Typography>
                                            <Typography style={{ fontFamily: 'Poppins' }}>{item.facility_location}</Typography>
                                            <div style={{ marginTop: 10 }}>
                                                <Typography style={{ fontFamily: 'Poppins', color: item.facility_session_status === "Aktif" ? '#3bbf50' : item.facility_session_status === "Hold" ? '#ff5b5b' : item.facility_session_status === "Berhenti" ? '#ffa654' : 'black', fontSize: 11 }}>Status {item.facility_session_status}</Typography>
                                                <Typography style={{ fontFamily: 'Poppins', color: 'black', fontSize: 11 }}>Tanggal : {item.facility_schedule_date ? format(new Date(item.facility_schedule_date), 'dd MMM yyyy') : "-"}</Typography>
                                            </div>
                                        </div>
                                    </div>
                                    {item.facility_is_nonstop !== 1 ?
                                        <div style={{ display: 'flex', justifyContent: 'space-between', borderBottomColor: '#d2d2d2', borderBottomStyle: 'solid', borderBottomWidth: 2, width: '90%', margin: 'auto' }}>
                                            <div style={{}}>
                                                <Typography style={{ color: '#bdc3c7', fontSize: 12, fontFamily: 'Poppins' }}>Jam Buka</Typography>
                                                <Typography style={{ color: 'black', fontFamily: 'Poppins' }}>{item.facility_start === null ? "" : item.facility_start.slice(0, 5)}</Typography>
                                            </div>
                                            <div style={{ marginLeft: 20 }}>
                                                <Typography style={{ color: '#bdc3c7', fontSize: 12, fontFamily: 'Poppins' }}>Jam Tutup</Typography>
                                                <Typography style={{ color: 'black', fontFamily: 'Poppins' }}>{item.facility_end === null ? "" : item.facility_end.slice(0, 5)}</Typography>
                                            </div>
                                            <div style={{ marginLeft: 20 }}>
                                                <Typography style={{ color: '#bdc3c7', fontSize: 12, fontFamily: 'Poppins' }}>Jumlah Loket</Typography>
                                                <Typography style={{ color: 'black', fontFamily: 'Poppins' }}>{item.facility_counters}</Typography>
                                            </div>
                                        </div> :
                                        <div style={{ display: 'flex', justifyContent: 'center', width: '90%', margin: 'auto' }}>
                                            <div style={{ marginLeft: 20 }}>
                                                <Typography style={{ color: '#bdc3c7', fontSize: 12, fontFamily: 'Poppins' }}>Jumlah Loket</Typography>
                                                <Typography style={{ color: 'black', textAlign: 'center', fontFamily: 'Poppins' }}>{item.facility_counters}</Typography>
                                            </div>
                                        </div>
                                    }
                                    {item.facility_is_nonstop !== 1 && create && update ?
                                        <div>
                                            {
                                                item.facility_session_status === "Mulai" ?
                                                    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '0px 20px' }}>
                                                        <div style={{ width: '33%', borderRightColor: '#ebebeb', borderRightStyle: 'solid', borderRightWidth: 1, alignSelf: 'center', }}>
                                                            <Typography style={{ color: '#3bbf50', fontSize: "90%", fontWeight: 'bold', fontFamily: 'Poppins', textAlign: 'center' }}>Mulai Loket</Typography>
                                                        </div>
                                                        <div style={{ cursor: 'pointer', width: '33%', alignSelf: 'center', borderRightColor: '#ebebeb', borderRightStyle: 'solid', borderRightWidth: 1 }} onClick={() => handleHold(item)}>
                                                            <Typography style={{ color: '#ffa654', fontSize: "90%", fontWeight: 'bold', fontFamily: 'Poppins', textAlign: 'center' }}>Tunda Loket</Typography>
                                                        </div>
                                                        <div style={{ cursor: 'pointer', width: '33%', alignSelf: 'center', }} onClick={() => handleStop(item)}>
                                                            <Typography style={{ color: '#ff5b5b', fontSize: "90%", fontWeight: 'bold', fontFamily: 'Poppins', textAlign: 'center' }}>Berhenti</Typography>
                                                        </div>
                                                    </div>
                                                    :
                                                    item.facility_session_status === "Tunda" ?
                                                        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '0px 20px' }}>
                                                            <div style={{ width: '33%', borderRightColor: '#ebebeb', borderRightStyle: 'solid', borderRightWidth: 1, alignSelf: 'center', }} >
                                                                <Typography style={{ color: '#3bbf50', fontSize: "90%", fontWeight: 'bold', fontFamily: 'Poppins', textAlign: 'center' }}>Mulai Loket</Typography>
                                                            </div>
                                                            <div style={{ cursor: 'pointer', width: '33%', alignSelf: 'center', borderRightColor: '#ebebeb', borderRightStyle: 'solid', borderRightWidth: 1 }} onClick={() => handleStart(item)}>
                                                                <Typography style={{ color: '#ffa654', fontSize: "90%", fontWeight: 'bold', fontFamily: 'Poppins', textAlign: 'center' }}>Lanjut Loket</Typography>
                                                            </div>
                                                            <div style={{ cursor: 'pointer', width: '33%', alignSelf: 'center', }} onClick={() => handleStop(item)}>
                                                                <Typography style={{ color: '#ff5b5b', fontSize: "90%", fontWeight: 'bold', fontFamily: 'Poppins', textAlign: 'center' }}>Berhenti</Typography>
                                                            </div>
                                                        </div>
                                                        :
                                                        item.facility_session_status === "Berhenti" ?
                                                            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '0px 20px' }}>
                                                                <div style={{ width: '33%', borderRightColor: '#ebebeb', borderRightStyle: 'solid', borderRightWidth: 1, alignSelf: 'center', }}>
                                                                    <Typography style={{ color: '#3bbf50', fontSize: "90%", fontWeight: 'bold', fontFamily: 'Poppins', textAlign: 'center' }}>Mulai Loket</Typography>
                                                                </div>
                                                                <div style={{ width: '33%', alignSelf: 'center', borderRightColor: '#ebebeb', borderRightStyle: 'solid', borderRightWidth: 1 }}>
                                                                    <Typography style={{ color: '#ffa654', fontSize: "90%", fontWeight: 'bold', fontFamily: 'Poppins', textAlign: 'center' }}>Tunda Loket</Typography>
                                                                </div>
                                                                <div style={{ width: '33%', alignSelf: 'center', }}>
                                                                    <Typography style={{ color: '#ff5b5b', fontSize: "90%", fontWeight: 'bold', fontFamily: 'Poppins', textAlign: 'center' }}>Berhenti</Typography>
                                                                </div>
                                                            </div>
                                                            :
                                                            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '0px 20px' }}>
                                                                <div style={{ cursor: 'pointer', width: '33%', borderRightColor: '#ebebeb', borderRightStyle: 'solid', borderRightWidth: 1, alignSelf: 'center', }} onClick={() => handleStart(item)}>
                                                                    <Typography style={{ color: '#3bbf50', fontSize: "90%", fontWeight: 'bold', fontFamily: 'Poppins', textAlign: 'center' }}>Mulai Loket</Typography>
                                                                </div>
                                                                <div style={{ width: '33%', alignSelf: 'center', borderRightColor: '#ebebeb', borderRightStyle: 'solid', borderRightWidth: 1 }}>
                                                                    <Typography style={{ color: '#ffa654', fontSize: "90%", fontWeight: 'bold', fontFamily: 'Poppins', textAlign: 'center' }}>Tunda Loket</Typography>
                                                                </div>
                                                                <div style={{ width: '33%', alignSelf: 'center', }}>
                                                                    <Typography style={{ color: '#ff5b5b', fontSize: "90%", fontWeight: 'bold', fontFamily: 'Poppins', textAlign: 'center' }}>Berhenti</Typography>
                                                                </div>
                                                            </div>
                                            }
                                        </div>
                                        :
                                        null}

                                </Paper>
                            ))}
                        </GridList>
                    </div>
                </div>
            )}
            {visibleStatus && (
                <div className="App app-popup-show">
                    <div className="popup-content-middle background-white" style={{ borderRadius: 8, width: 520 }}>
                        <div className="popup-panel grid grid-2x" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                            <div className="col-1" />
                            <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center', padding: 0 }}>
                                <button
                                    type="button"
                                    className="btn btn-circle btn-white"
                                    onClick={() => setVisibleStatus(false)}
                                >
                                    <img src={CloseImage} style={{ width: 20, height: 20 }} />
                                </button>
                            </div>
                        </div>
                        <div style={{ padding: 20 }}>
                            <Typography style={{ textAlign: 'left', fontSize: 20 }}>Anda yakin ingin stop sesi loket {data.facility_name} ?. <span><b>Anda tidak dapat memulai sesi kembali jika sesi sudah diberhentikan dihari yang sama.</b> </span></Typography>
                        </div>
                        <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                            <div className="column-1" style={{ alignSelf: 'center' }}>
                            </div>
                            <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                <div
                                    onClick={() => setVisibleStatus(false)}
                                    style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                                    <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                                </div>
                                <div
                                    onClick={() => changeStatus()}
                                    style={{ height: 32, width: 150, backgroundColor: '#ff4252', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                    <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Konfirmasi</Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}